<template>
  <div>
    <nav-bar navBarTitle="VIP卡签名"></nav-bar>
    <div class="vipsign">
      <div class="card">
        <div class="card-t">
          尚未完成VIP卡签名
        </div>
        <div class="card-b" v-if="vipEndTime">
          VIP已开通，有效期至<span>{{ vipEndTime | vipEndDate}}</span>
        </div>
      </div>
      <div class="userinfoenter">
        <div class="title">请为您的VIP卡签名</div>
        <div class="enterbox">
          <div class="left">真实姓名</div>
          <input placeholder="请输入" v-model="userName" maxlength="20" class="rightinput" />
        </div>
        <div class="enterbox">
          <div class="left">职务</div>
          <input placeholder="请输入" v-model="companyPosition" maxlength="20" class="rightinput" />
          <div class="select" @click="showSelectLabel">快速选择</div>
          <ul class="selectlist" v-show="showLabel">
            <li v-for="(item, index) in labelList" :key="index" :class="{'select-li': companyPosition===item}" @click="selectCompanyPosition(item)">{{item}}</li>
          </ul>
        </div>
        <button class="btn" @click="updateInfo">一键完成VIP卡签名</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
import { reqPositonList, reqUpdateInfo } from '../../api'
import { checkEmojiRule } from '../../utils';
import { Toast } from 'vant'
export default {
  name: 'mySign',
  components: {
  },
  data() {
    return {
      userName: '',
      companyPosition: '',
      labelList: [],
      showLabel: false
    }
  },
  mounted() {
    if(!this.defaultUserName){
      this.userName = this.stateUserName ? this.stateUserName : ''
    }
    this.companyPosition = this.stateCompanyPosition ? this.stateCompanyPosition : ''
    this.getPositionList()
  },
  computed: {
		...mapState({
      stateUserName: state => state.userName,
      defaultUserName: state => state.defaultUserName,
      stateCompanyPosition: state => state.companyPosition,
      vipEndTime: state => state.vipEndTime
    }),
  },
  methods: {
    ...mapMutations({
      setPerson: 'SET_PERSON',
    }),
    //  获取职务列表
    getPositionList() {
      reqPositonList().then(res => {
        let resData = res.data
        if (resData.length) {
          this.labelList = resData.map(item => {
            return item.positionName
          })
        }
      })
    },
    showSelectLabel(){
      this.showLabel = !this.showLabel
    },
    selectCompanyPosition(item){
      this.companyPosition = item
      this.showLabel = false
    },
    // 更新用户信息
    updateInfo() {
      let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/g;
      if(!this.userName || !this.companyPosition){
        Toast('请正确填写信息')
        return
      }
      if(!reg.test(this.userName)){
        Toast('真实姓名请输入中文或字母')
        return
      }
      if(checkEmojiRule(this.companyPosition)){
        Toast('不能输入表情')
        return
      }
      let params = {
        userName: this.userName,
        companyPosition: this.companyPosition
      }
      reqUpdateInfo(params).then(res => {
        if (res.ok) {
          this.setPerson(params)
          this.$router.replace({path:'/vipsignsuccess'})
        }else{
          Toast(res.msg)
        }
      })
    },
  },
  filters: {
    vipEndDate: function (value) {
      return value.substr(0,16)
    }
  },
};
</script>

<style lang="less" scoped>
.vipsign {
  width: 100%;
  padding: 30px 16px 0;
  .card {
    width: 343px;
    height: 130px;
    background: url('../../assets/img/vipsignbg.png') top no-repeat;
    background-size: cover;
    padding: 40px 16px 0;
    .card-t {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
    }
    .card-b {
      font-size: 12px;
      color: #7C561E;
      line-height: 12px;
      margin-top: 36px;
    }
  }
  .userinfoenter {
    .title {
      font-size: 14px;
      line-height: 14px;
      color: #333333;
      padding: 26px 0 22px;
      text-align: center;
    }
    .enterbox{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #333333;
      position: relative;
      height: 53px;
      .left{
        width: 80px;
      }
      .rightinput{
        flex-grow: 2;
        border: none;
        background: none;
      }
      .select{
        padding: 0 6px;
        line-height: 20px;
        border-radius: 2px;
        border: 1px solid #C89557;
        font-size: 10px;
        color: #C89557;
        margin-left: 15px;
        flex-shrink: 0;
      }
      .selectlist{
        width: 100%;
        background: #ffffff;
        position: absolute;
        left: 0;
        top: 70px;
        display: flex;
        flex-wrap: wrap;
        li{
          width: 31%;
          line-height: 34px;
          text-align: center;
          background: #F8F8F8;
          border-radius: 3px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin: 0 10px 10px 0;
          &.select-li{
            color: #C89557;
            background: #FAF3E9;
          }
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
      &::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        transform: scaleY(0.5);
        background: #EEEEEE;
      }
    }
    .btn{
      width: 100%;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #C89557;
      font-size: 16px;
      color: #C89557;
      background: none;
      margin-top: 41px;
    }
  }
}
</style>
